import { useEffect } from "react";
import styles from "./basic-tools-step.module.css";
import { getPathPrefix } from "utils/getPathPrefix";
import { CursorType } from "frontend/canvas-designer-new/cursor-type";
import { getMenuItemIdSelector } from "frontend/canvas-designer-new/sidebar/side-menu-items/side-menu-items";

export default function BasicToolsStep() {
  useEffect(() => {
    const toolIds = [CursorType.shape, CursorType.stickyNote, CursorType.draw];
    const unhighlightToolIds = [CursorType.pointer];
    const elements: HTMLElement[] = [];
    const unhighlightElements: HTMLElement[] = [];

    // Find and add highlight class to elements
    for (const toolId of toolIds) {
      const element = document.getElementById(getMenuItemIdSelector(toolId)) as HTMLElement;
      if (element) {
        element.classList.add(styles.highlightedTool);
        elements.push(element);
      }
    }

    for (const unhighlightToolId of unhighlightToolIds) {
      const element = document.getElementById(getMenuItemIdSelector(unhighlightToolId)) as HTMLElement;
      if (element) {
        element.classList.add(styles.unhighlightTool);
        unhighlightElements.push(element);
      }
    }

    // Cleanup function to remove highlight class
    return () => {
      for (const element of elements) {
        element.classList.remove(styles.highlightedTool);
      }
      for (const element of unhighlightElements) {
        element.classList.remove(styles.unhighlightTool);
      }
    };
  }, []);

  return (
    <div className={styles.container}>
      <img src={getPathPrefix("/images/onboarding/cim/basic-tools.png")} alt="Basic Tools" className={styles.image} />
    </div>
  );
}
